import React from 'react'

export default function ProductDetail() {
  return (
    <div>
      Product Detail
    </div>
  )
}
